<template>
  <path
    d="M7.3749,14.2501c-1.3597,0-2.6889-.4032-3.8195-1.1586-1.1306-.7554-2.0117-1.8292-2.5321-3.0854-.5203-1.2563-.6565-2.6386-.3912-3.9722.2653-1.3336.92-2.5586,1.8815-3.5201.9615-.9615,2.1865-1.6163,3.5201-1.8815,1.3336-.2653,2.7159-.1291,3.9721.3912,1.2562.5204,2.3299,1.4015,3.0853,2.5321.7554,1.1306,1.1586,2.4598,1.1586,3.8196M7.3749,11.375c-.7911,0-1.5644-.2346-2.2222-.6741-.6578-.4395-1.1705-1.0642-1.4732-1.7951-.3028-.7309-.382-1.5352-.2276-2.3111.1543-.7759.5353-1.4886,1.0947-2.0481.5594-.5594,1.2721-.9404,2.048-1.0947.7759-.1543,1.5802-.0751,2.3111.2276.7309.3027,1.3556.8154,1.7951,1.4732.4395.6578.6741,1.4311.6741,2.2223"
    fill="none"
    stroke="#fddc03"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width=".6667"
  />
  <path
    d="M7.3749,8.375c.5523,0,1-.4477,1-1s-.4477-1-1-1-1,.4477-1,1,.4477,1,1,1Z"
    fill="none"
    stroke="#fddc03"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width=".6667"
  />
  <path
    d="M15.5,15.5l-6.0249-6.025M9.4751,9.475l4.3249.4M9.4751,9.475l.35,4.35"
    fill="none"
    stroke="#fddc03"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width=".6667"
  />
</template>
